if (!customElements.get('pt-find-your-match')) {
  customElements.define('pt-find-your-match', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const tablist = this.querySelector('.pt-find-match__tabs');
      const tabs = Array.from(tablist.querySelectorAll('button'));
      const panels = Array.from(this.querySelectorAll('[data-match-panel]'));
      const activate = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      };
      tablist.setAttribute('role', 'tablist');
      tablist.setAttribute('aria-label', 'Find your pajamas by people, fabric or just for me');
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(next, true); }
        });
      });
      this.classList.add('pt-find-match--enhanced');
      activate(0);
      tablist.hidden = false;
    }
  });
}
